import Vue from 'vue'
import MainContent from 'MainContent'
import CenterContent from 'CenterContent'
import VueRouter from 'vue-router'
import store from '../store'
import '../config'
import WorkOrderDetail from 'Dashboard/WorkOrder/MyWorkOrder/Detail'
import menu from 'constant/menu'

Vue.use(VueRouter)
Vue.config.productionTip = false

// 同步加载首页Dashboard

// 惰性加载其余页面 Dashboard

//  应用管理
const MyApp = resolve =>
  require.ensure([], () =>
    resolve(require('Dashboard/App/MyApp/Main')), 'myapp')
const AppMap = resolve =>
  require.ensure([], () =>
    resolve(require('Dashboard/App/Map/Main')), 'appmap')
const ServiceManage = resolve =>
  require.ensure([], () =>
    resolve(require('Dashboard/App/MyApp/ServiceManage')), 'servicemanage')
const AiuiApp = resolve =>
  require.ensure([], () =>
    resolve(require('Dashboard/App/AiuiApp/Main')), 'aiuiapp')
const Create = resolve =>
  require.ensure([], () =>
    resolve(require('Dashboard/App/Create/Main')), 'create')
const Edit = resolve =>
  require.ensure([], () =>
    resolve(require('Dashboard/App/Create/Edit')), 'edit')
const Sdk = resolve =>
  require.ensure([], () =>
    resolve(require('Dashboard/App/Sdk/Main')), 'sdk')
const Audit = resolve =>
  require.ensure([], () =>
    resolve(require('Dashboard/App/Audit/Main')), 'sdk')
// 服务监控
const Services = resolve =>
  require.ensure([], () =>
    resolve(require('Dashboard/App/Services/Main')), 'services')
const History = resolve =>
  require.ensure([], () =>
    resolve(require('Dashboard/App/Services/History')), 'history')
// 财务中心
const Account = resolve =>
  require.ensure([], () =>
    resolve(require('Dashboard/Center/Account/Main')), 'account')
const GiftCard = resolve =>
  require.ensure([], () =>
    resolve(require('Dashboard/Center/GiftCard/Main')), 'giftCard')
const Coupon = resolve =>
  require.ensure([], () =>
    resolve(require('Dashboard/Center/Coupon/Main')), 'coupon')
const Charge = resolve =>
  require.ensure([], () =>
    resolve(require('Dashboard/Center/Charge/Main')), 'charge')
const BankOffline = resolve =>
  require.ensure([], () =>
    resolve(require('Dashboard/Center/Charge/Bank')), 'bank')
const GiftPackage = resolve =>
  require.ensure([], () =>
    resolve(require('Dashboard/Center/GiftPackage/Main')), 'giftPackage')
const Cart = resolve =>
  require.ensure([], () =>
    resolve(require('Dashboard/Center/Cart/Main')), 'cart')
const Order = resolve =>
  require.ensure([], () =>
    resolve(require('Dashboard/Center/Order/Main')), 'order')
const OrderDetail = resolve =>
  require.ensure([], () =>
    resolve(require('Dashboard/Center/Order/OrderDetail')), 'orderdetail')
const Contract = resolve =>
  require.ensure([], () =>
    resolve(require('Dashboard/Center/Contract/Main')), 'contract')
const ContractApplication = resolve =>
  require.ensure([], () =>
    resolve(require('Dashboard/Center/Contract/Application')), 'contractApplication')
const Invoice = resolve =>
  require.ensure([], () =>
    resolve(require('Dashboard/Center/Invoice/Main')), 'invoice')
    // 购买支付流程
const Buy = resolve =>
  require.ensure([], () =>
    resolve(require('Dashboard/Sale/Buy/Main')), 'buy')
const CartBuy = resolve =>
  require.ensure([], () =>
    resolve(require('Dashboard/Sale/CartBuy/Main')), 'cartbuy')
const BuyCoupon = resolve =>
  require.ensure([], () =>
    resolve(require('Dashboard/Sale/Buy/BuyCoupon')), 'buycoupon')
const Pay = resolve =>
  require.ensure([], () =>
    resolve(require('Dashboard/Sale/Pay/Main')), 'pay')
const PayWay = resolve =>
  require.ensure([], () =>
    resolve(require('Dashboard/Sale/PayWay/Main')), 'payway')
const PaySuccess = resolve =>
  require.ensure([], () =>
    resolve(require('Dashboard/Sale/Pay/Success')), 'paysuccess')
// 用户中心
const PersonalData = resolve =>
  require.ensure([], () =>
    resolve(require('Dashboard/User/PersonalData/Main')), 'personaldata')
// const RealNameAuth = resolve =>
//   require.ensure([], () =>
//     resolve(require('Dashboard/User/RealNameAuth/Main')), 'realnameauth')
// const SecurityConfig = resolve =>
//   require.ensure([], () =>
//     resolve(require('Dashboard/User/RealNameAuth/Main')), 'securityconfig')
const MyWorkOrder = resolve =>
  require.ensure([], () =>
    resolve(require('Dashboard/WorkOrder/MyWorkOrder/Main')), 'myworkorder')
const CreateWorkOrder = resolve =>
  require.ensure([], () =>
    resolve(require('Dashboard/WorkOrder/Create/Main')), 'commit')
// 消息中心
const MessageCenter = resolve =>
  require.ensure([], () =>
    resolve(require('Dashboard/User/MessageCenter/Main')), 'msgcenter')
const MessageDetail = resolve =>
  require.ensure([], () =>
    resolve(require('Dashboard/User/MessageCenter/Detail')), 'msgdetail')
// 搜索
const Partner = resolve =>
  require.ensure([], () =>
    resolve(require('Dashboard/Search/Partner/Main')), 'partner')

//新版用户中心
const BaseInfo = resolve =>
  require.ensure([], () =>
    resolve(require('Dashboard/User/Profile/Main')), 'baseinfo')
const Authentication = resolve =>
  require.ensure([], () =>
    resolve(require('Dashboard/User/Authentication/Main')), 'authentication')
const Personal = resolve =>
  require.ensure([], () =>
    resolve(require('Dashboard/User/RealNameAuth/Personal')), 'company')
const Company = resolve =>
  require.ensure([], () =>
    resolve(require('Dashboard/User/RealNameAuth/Company')), 'company')
const Student = resolve =>
  require.ensure([], () =>
    resolve(require('Dashboard/User/RealNameAuth/Student')), 'company')
const Syb = resolve =>
  require.ensure([], () =>
    resolve(require('Dashboard/User/RealNameAuth/Syb')), 'company')
//个人认证变更
const ChangeAuthentication = resolve =>
  require.ensure([], () =>
    resolve(require('Dashboard/User/Authentication/ChangeAuthentication')), 'changeauthentication')
const ChangePersonalAuth = resolve =>
  require.ensure([], () =>
    resolve(require('Dashboard/User/Authentication/ChangePersonalAuth')), 'changepersonalauth')
const ChangeCompanyAuth = resolve =>
  require.ensure([], () =>
  resolve(require('Dashboard/User/Authentication/ChangeCompanyAuth')), 'changecompanyauth')
const Security = resolve =>
  require.ensure([], () =>
    resolve(require('Dashboard/User/Profile/Security')), 'security')
const router = new VueRouter({
  base: __dirname,
  mode: 'history',
  routes: [{
    path: '/',
    redirect: '/app'
  },
  {
    path: '/services',
    component: MainContent,
    children: [
      {
        path: 'history',
        components: {
          dashboard: History
        }
      }, {
      path: '*',
      components: {
        dashboard: Services
      }
    }]
  },
  {
    path: '/app',
    component: MainContent,
    children: [{
      path: '',
      redirect: 'myapp'
    },
    {
      path: 'myapp',
      components: {
        dashboard: AppMap
      }
    },
    // {
    //   path: 'map',
    //   components: {
    //     dashboard: AppMap
    //   }
    // },
    {
      path: 'servicemanage',
      components: {
        dashboard: ServiceManage
      }
    },
    {
      path: 'aiuiapp',
      components: {
        dashboard: AiuiApp
      }
    },
    {
      path: 'create',
      components: {
        dashboard: Create
      }
    },
    {
      path: 'sdk',
      components: {
        dashboard: Sdk
      }
    },
    {
      path: 'audit',
      components: {
        dashboard: Audit
      }
    },
    {
      path: 'edit',
      components: {
        dashboard: Edit
      }
    }
    ]
  },
  {
    path: '/center',
    component: MainContent,
    children: [
      {
        path: '',
        redirect: 'account'
      },
      {
        path: 'account',
        components: {
          dashboard: Account
        }
      },
      {
        path: 'giftCard',
        components: {
          dashboard: GiftCard
        }
      },
      {
        path: 'coupon',
        components: {
          dashboard: Coupon
        }
      },
      {
        path: 'charge',
        components: {
          dashboard: Charge
        }
      },
      {
        path: 'offline',
        components: {
          dashboard: BankOffline
        }
      },
      {
        path: 'giftPackage',
        components: {
          dashboard: GiftPackage
        }
      },
      {
        path: 'cart',
        components: {
          dashboard: Cart
        }
      },
      {
        path: 'order',
        components: {
          dashboard: Order
        }
      },
      {
        path: 'orderdetail',
        components: {
          dashboard: OrderDetail
        }
      },
      {
        path: 'contract',
        components: {
          dashboard: Contract
        }
      },
      {
        path: 'invoice',
        components: {
          dashboard: Invoice
        }
      },
    ]
  },
  {
    path: '/sale',
    component: CenterContent,
    children: [{
      path: 'buy',
      components: {
        dashboard: Buy
      }
    },
    {
      path: 'cartbuy',
      components: {
        dashboard: CartBuy
      }
    },
    {
      path: 'buycoupon',
      components: {
        dashboard: BuyCoupon
      }
    },
    {
      path: 'pay',
      components: {
        dashboard: Pay
      }
    },
    {
      path: 'payway',
      components: {
        dashboard: PayWay
      }
    },
    {
      path: 'paysuccess',
      components: {
        dashboard: PaySuccess
      }
    }
    ]
  },
  {
    path: '/user',
    component: MainContent,
    children: [{
      path: '',
      redirect: 'personaldata'
    },
    {
      // 老版本认证页面，重定向至新认证页
      path: 'personaldata',
      redirect: 'baseinfo'
    },
    {
      path: 'baseinfo',
      components: {
        dashboard: BaseInfo
      }
    },
    {
      path: 'authentication',
      components: {
        dashboard: Authentication
      }
    },
    {
      path: 'authentication/personal',
      components: {
        dashboard: Personal
      }
    },
    {
      path: 'authentication/company',
      components: {
        dashboard: Company
      }
    },
    {
      path: 'student',
      components: {
        dashboard: Student
      }
    },
    {
      path: 'syb',
      components: {
        dashboard: Syb
      }
    },
    {
      path: 'changeauthentication',
      components: {
        dashboard: ChangeAuthentication
      }
    },
    {
      path: 'changecompanyauth',
      components: {
        dashboard: ChangeCompanyAuth
      }
    },
    {
      path: 'changepersonalauth',
      components: {
        dashboard: ChangePersonalAuth
      }
    },
    // {
    //   path: 'realnameauth',
    //   components: {
    //     dashboard: RealNameAuth
    //   }
    // },
    {
      path: 'securityconfig',
      components: {
        dashboard: PersonalData
      }
    },
    {
      path: 'security',
      name: 'security',
      components: {
        dashboard: Security
      }
    },

    {
      path: 'msgcenter',
      components: {
        dashboard: MessageCenter
      }
    },
    {
      path: 'msgdetail',
      components: {
        dashboard: MessageDetail
      }
    }
    ]
  },
  {
    path: '/logout',
    beforeEnter(to, from, next) {
      store.dispatch('logout', function () {
        // location.href=Url[Mode].baseUrl
      })
    }
  },
  {
    path: '/workorder',
    component: MainContent,
    children: [{
      path: '',
      redirect: 'myworkorder'
    },
    {
      path: 'myworkorder',
      components: {
        dashboard: MyWorkOrder
      }
    },
    {
      path: 'commit',
      components: {
        dashboard: CreateWorkOrder
      }
    }, {
      path: 'detail',
      components: {
        dashboard: WorkOrderDetail
      }
    }
    ]
  },
  {
    path: '/search',
    component: MainContent,
    children: [{
      path: '',
      redirect: 'partner'
    },
    {
      path: 'partner',
      components: {
        dashboard: Partner
      }
    }]
  },
  { path: '/user/realnameauth', redirect: '/user/authentication' },
  {
    path: '/*',
    redirect: '/'
  }
  ]
})

const SERVICE_PATH_ARRAY = menu.reduce((result, item) => {
  let temp = result
  if (item.path) {
    temp = temp.concat(item)
  }
  if (item.submenu) {
    temp = temp.concat(item.submenu)
  }
  return temp
}, [])

// 滚动行为
router.beforeEach((to, from, next) => {
  store.dispatch('setPreMenu', from.path.split('/')[2])
  store.dispatch('setMenu', to.path.split('/')[2])
  // 记录最后一个点击的服务卡片，切换应用时默认跳转至此服务
  if (
    SERVICE_PATH_ARRAY.findIndex(item => item.path === from.path) >= 0 && 
    SERVICE_PATH_ARRAY.findIndex(item => item.path === to.path) < 0
  ) {
    store.dispatch('setServiceFootprint', from.path)
  }
  window.scrollTo(0, 0)
  next()
})

export default router



// WEBPACK FOOTER //
// ./app/router/index.js